import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../packages/auth-client';

/**
 * SuperAdminRoute — only renders children for superadmin users.
 * All other authenticated users are redirected to /dashboard.
 */
export function SuperAdminRoute() {
    const { isSuperAdmin } = useAuth();
    return isSuperAdmin() ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
